import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../../../api/apiClient';
import { FaArrowLeft } from 'react-icons/fa';

const AssessmentResult = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const journeyContext = location.state?.journeyContext;
  const [result, setResult] = useState(null);
  const [attemptHistory, setAttemptHistory] = useState([]);

  useEffect(() => {
    const fetchResult = async () => {
      try {
        const response = await api.assessments.getUserResult(id);
        setResult(response.data.data?.latest_result || null);
        setAttemptHistory(response.data.data?.attempt_history || []);
      } catch (error) {
        toast.error(error.response?.data?.message || 'Failed to load result');
      }
    };
    fetchResult();
  }, [id]);

  if (!result) {
    return <div className="text-center py-8">Loading result...</div>;
  }

  return (
    <div className="p-6 bg-gradient-to-br from-purple-50 via-white to-indigo-50 min-h-screen">
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow p-6">
        <button
          onClick={() => journeyContext
            ? navigate(`/user/learning-journeys/${journeyContext.journeyId}`)
            : navigate('/user/assessments')}
          className="flex items-center gap-2 px-4 py-2 mb-4 bg-white border border-purple-300 text-purple-700 rounded-lg shadow-sm hover:bg-purple-50 transition-all duration-200 text-sm font-medium"
        >
          <FaArrowLeft className="w-4 h-4" /> {journeyContext ? 'Back to Journey' : 'Back to Assessments'}
        </button>
        <h3 className="mb-4">Assessment Result</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <div className="rounded-lg bg-purple-50 p-3"><strong>Obtained Marks:</strong> {result.obtained_marks}</div>
          <div className="rounded-lg bg-blue-50 p-3"><strong>Total Marks:</strong> {result.total_marks}</div>
          <div className="rounded-lg bg-emerald-50 p-3"><strong>Percentage:</strong> {result.percentage}%</div>
          <div className="rounded-lg bg-amber-50 p-3"><strong>Status:</strong> {result.result_status}</div>
        </div>

        <div className="mt-6">
          <h5 className="mb-3">Attempt History</h5>
          {attemptHistory.length === 0 ? (
            <p className="text-sm text-gray-600 mb-0">No attempt history available.</p>
          ) : (
            <div className="overflow-x-auto">
              <table className="table table-bordered table-hover mb-0 text-sm">
                <thead className="bg-gradient-to-r from-purple-600 to-pink-600 text-white">
                  <tr>
                    <th>#</th>
                    <th>Obtained</th>
                    <th>Total</th>
                    <th>Percentage</th>
                    <th>Status</th>
                    <th>Submitted On</th>
                  </tr>
                </thead>
                <tbody>
                  {attemptHistory.map((item, index) => (
                    <tr key={`attempt-history-${item.id}`}>
                      <td>{index + 1}</td>
                      <td>{item.obtained_marks}</td>
                      <td>{item.total_marks}</td>
                      <td>{item.percentage}%</td>
                      <td className="capitalize">{item.result_status?.replaceAll('_', ' ')}</td>
                      <td>{item.attempt?.submitted_at ? new Date(item.attempt.submitted_at).toLocaleString() : '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AssessmentResult;
